import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TextareaComponent } from '../textarea/textarea.component';

@Component({
  selector: 'app-note-dialog',
  templateUrl: './note-dialog.component.html',
  styleUrls: ['./note-dialog.component.scss']
})
export class NoteDialogComponent implements OnInit {

  @Input() header: string = '';
  @Input() headerExtension: string = '';
  @Input() placeholder: string = 'Add note';
  @Input() submitBtnText: string = 'Add';
  @Input()
  set initialValue(value: string) {
    setTimeout(() => {
      this.textArea?.initInitialValue(value);
      this.cdr.detectChanges();
    });
  }
  @Input() withDeleteBtn: boolean;

  @Input() height: number;
  @Input() width: number = 468;
  @Input() withOptionToClear: boolean;

  @Output() close = new EventEmitter<void>();
  @Output() submit = new EventEmitter<string>();
  @Output() delete = new EventEmitter<void>();

  @ViewChild('textarea') textArea: TextareaComponent;
  @ViewChild('submitButton') submitButton;
  @ViewChild('closeButton') closeButton;

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  focus() {
  }
  
  clear(): void { 
    this.textArea?.clear();
    this.textArea?.focus();
  }

 focusTextArea(): void {
    event.stopPropagation();
    event.preventDefault();
    this.textArea?.focus();
 }
}
